import * as React from "react";
import { UitkButtonToggle } from "uitk-react-button-toggle";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { LobNavigationItemProps, LobNavigationItemFTNodeOptions } from "./typings";
import { useLocalization } from "@shared-ui/localization-context";
import { Link } from "react-router-dom";
import { wizardLobQueryParamKey } from "../constants";
import { hasEmptyOptions, normalizeOptionsData } from "src/components/flexFramework/FlexTemplateNode";
import { UitkText } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";

const LobNavigationItem = (props: LobNavigationItemProps) => {
  const { formatText } = useLocalization();
  const {
    flexTemplateNode,
    flexModuleModelStore,
    isTabChecked,
    getLabel,
    getLobIcon,
    searchParams,
    handleLobChange,
    index,
    lobsLength,
  } = props;

  const options = normalizeOptionsData(
    flexTemplateNode,
    flexModuleModelStore.getModel(flexTemplateNode.id)
  ) as LobNavigationItemFTNodeOptions;

  /**
   * This hook is reached for rehydratation, so if JS is enabled there is no need of use a Link component
   * for a hard refresh, so the value is changed to false, if JS is disabled then this hook is never executed
   */
  React.useEffect(() => setUseLink(false), []);
  const [useLink, setUseLink] = React.useState(true);

  if (!options || hasEmptyOptions(options)) {
    return null;
  }

  const { flexComponentName } = options;

  const buttonLabel = getLabel(flexComponentName);
  const ariaLabel = formatText("wizard.lob.tab.alttext", buttonLabel, index + 1, lobsLength);
  const isButtonChecked = isTabChecked(flexComponentName);
  const buttonIcon = getLobIcon(flexComponentName);

  const whereToGo = () => {
    const { directLink } = options;

    if (directLink) {
      return directLink;
    }

    const searchParam = new URLSearchParams(searchParams);
    searchParam.set(wizardLobQueryParamKey, flexComponentName);

    return `?${searchParam.toString()}`;
  };

  return (
    <UitkLayoutFlexItem grow={1} className="lobItem">
      <UitkSpacing margin={{ inlineend: "one", blockend: "six" }}>
        <li role="presentation">
          {useLink ? (
            <Link to={whereToGo()} className="ssr-lob-btn" role="tab" rel="nofollow">
              <UitkButtonToggle checked={isButtonChecked} icon={buttonIcon} name={flexComponentName} />
            </Link>
          ) : (
            <div role="tab">
              <UitkButtonToggle
                checked={isButtonChecked}
                icon={buttonIcon}
                id={flexComponentName}
                onChange={handleLobChange(flexComponentName, options)}
                aria-label={ariaLabel}
                data-testid={flexComponentName}
              />
            </div>
          )}
          <UitkSpacing margin={{ blockstart: "two" }}>
            <UitkText align="center" size={100} aria-hidden="true">
              {buttonLabel}
            </UitkText>
          </UitkSpacing>
        </li>
      </UitkSpacing>
    </UitkLayoutFlexItem>
  );
};

export default LobNavigationItem;
